import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import sha256 from 'crypto-js/sha256';
import { Link } from 'react-router-dom';
import UtmManager from './UtmValue';
import Select from 'react-select';

const API_CONFIG = {
  baseURL: process.env.REACT_APP_BACKEND_URL,
  ImageUrl: process.env.REACT_APP_IMAGES_URL,
  getUserToken: () => Cookies.get('UserSpecialToken')
};

const request = async (endpoint, options = {}) => {
  const token = API_CONFIG.getUserToken();
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
    'Accept': 'application/json'
  };

  try {
    const response = await fetch(`${API_CONFIG.baseURL}${endpoint}`, {
      ...options,
      headers: headers,
      body: options.body
    });

    const data = await response.json();

    if (!response.ok) {
      if (response.status === 422 && data.errors) {
        const validationErrors = Object.values(data.errors).flat();
        throw new Error(validationErrors.join(', ') || 'Validation failed.');
      }
      throw new Error(data.message || 'API request failed');
    }
    return data;
  } catch (error) {
    throw error;
  }
};

const UtmValueQuickForm = ({ typeToCreate, onSuccess, onCancel, LanguageSelected, t }) => {
  const [formData, setFormData] = useState({
    name: '',
    type: typeToCreate
  });
  const [InputsErrors, setInputsErrors] = useState({});
  const [isFetching, setIsFetching] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setInputsErrors({});
    setIsFetching(true);

    try {
      await request('/utm-values', {
        method: 'POST',
        body: JSON.stringify(formData)
      });
      toast.success(t(`New ${typeToCreate} value created successfully`), {
        position: toast.POSITION.CENTER
      });
      onSuccess();
    } catch (error) {
      setInputsErrors({ submit: error.message });
      toast.error(error.message, {
        position: toast.POSITION.CENTER
      });
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="grid place-items-center w-full py-4 gap-4 px-4">

      {/* <div className="w-full">
        <label className='block text-sm font-medium text-gold mb-1'>{t("type")}</label>
        <input
          type="text"
          value={t(typeToCreate)}
          disabled
          className="appearance-none block placeholder-sm w-full px-3 py-2 bg-gray-600 border-2 border-gray-500 rounded placeholder-gray-111 text-gray-400 cursor-not-allowed sm:text-sm"
        />
      </div> */}

      <div className="w-full">
        <input
          type="text"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          placeholder={t("name")}
          className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm"
          required
          autoFocus
        />
        {InputsErrors.name && (
          <p className="mt-2 text-red-600 dark:text-red-500 text-xs">{InputsErrors.name}</p>
        )}
      </div>

      <div className='flex gap-2 w-full'>
        <button
          type="submit"
          disabled={isFetching || !formData.name}
          className='flex-1 btn-edit'
        >
          {isFetching ? (
            <svg className="w-4 h-4 text-gray-300 animate-spin mx-auto" viewBox="0 0 64 64" fill="none">
              <circle cx="32" cy="32" r="30" stroke="currentColor" strokeWidth="5" />
            </svg>
          ) : (
            t('create')
          )}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className='flex-1 btn-cancel'
        >
          {t('cancel')}
        </button>
      </div>
    </form>
  );
};
//dddddddd



const UtmSelectd = ({
  name,
  label,
  options = [],
  value,
  onChange,
  LanguageSelected,
  error,
  utmType,
  onAddValue
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const status = Cookies.get('UserStatus');
  const company = Cookies.get('IdEntreprise');
  const toggle = () => setIsOpen(!isOpen);

  const filteredOptions = options.filter(opt =>
    opt.label.toLowerCase().includes(search.toLowerCase())
  );

  const selectedLabel =
    options.find(opt => opt.value === value)?.label || null;

  const handleSelect = (item) => {
    onChange({
      target: {
        name,
        value: item.value
      }
    });
    setIsOpen(false);
  };

  const clearValue = () => {
    onChange({
      target: {
        name,
        value: null
      }
    });
  };

  return (
    <div className="relative w-full mt-4">
      <div className='flex'>



        <div className="relative block w-full placeholder-sm px-3 py-2 sections
                    border border-transparent rounded placeholder-gray-111
                    text-black sm:text-sm">
          <a onClick={toggle} className="mr-2 text-theme cursor-pointer">
            {selectedLabel || label}
          </a>

          {value && (
            <a onClick={clearValue}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className={`lucide ${LanguageSelected === 'ar' ? 'left-10' : 'right-10'}
                  rounded-full p-1 div-sections cursor-pointer
                  top-4 text-theme absolute`}
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </a>
          )}

          <svg
            onClick={toggle}
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={`lucide ${LanguageSelected === 'ar' ? 'left-3' : 'right-3'}
              top-4 text-theme absolute cursor-pointer`}
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </div>

        {/* button add plus  */}
        {(status === 'Admin' || (!company || company === "null")) && (
          <button
            type="button"
            onClick={() => onAddValue(utmType)}
            title={t("add_new_utm_value", { type: label })}
            className="m-2 flex items-center justify-center bg-gray-700 border-2 border-gold
               rounded-full hover:bg-gold hover:text-black transition-colors text-gold w-6 h-6"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
          </button>
        )}
      </div>

      <div
        className={`absolute z-50 w-full h-72 overflow-y-auto mt-2 rounded-md
          shadow-lg sections p-1 space-y-1
          ${isOpen ? '' : 'hidden'}`}
      >

        <input
          className="appearance-none block w-full placeholder-sm px-3 py-2
                     div-sections border border-transparent rounded
                     placeholder-gray-111 text-black sm:text-sm"
          placeholder={t("Search")}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {filteredOptions.map(item => (
          <a
            key={item.value}
            onClick={() => handleSelect(item)}
            className="block px-4 py-2 text-theme cursor-pointer rounded-md"
          >
            {item.label}
          </a>
        ))}

        {error && (
          <p className="mt-2 text-red-600">
            <span className="font-xsmall">{error}</span>
          </p>
        )}
      </div>
    </div>
  );
};


//dddddddd
const UtmCombinationForm = ({ initialData, utmValues, onSuccess, t, LanguageSelected, onUtmValuesChange }) => {
  const utmTypes = ['source', 'medium', 'campaign', 'term', 'content'];
  
  const initialForm = {
    source_id: initialData?.source_id || '',
    medium_id: initialData?.medium_id || '',
    campaign_id: initialData?.campaign_id || '',
    term_id: initialData?.term_id || '',
    content_id: initialData?.content_id || '',
  };

  const [formData, setFormData] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [InputsErrors, setInputsErrors] = useState({});
  const isEditing = !!initialData?.id;
  const [showValueModal, setShowValueModal] = useState(false);
  const [valueTypeToCreate, setValueTypeToCreate] = useState(null);
  const [localUtmValues, setLocalUtmValues] = useState(utmValues);
  const status = Cookies.get('UserStatus');
  const company = Cookies.get('IdEntreprise');

  useEffect(() => {
    setLocalUtmValues(utmValues);
  }, [utmValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setInputsErrors({});
    setLoading(true);

    const payload = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => [key, value || null])
    );

    try {
      let responseData;

      if (isEditing) {
        responseData = await request(`/utms/${initialData.id}`, {
          method: 'PUT',
          body: JSON.stringify(payload)
        });
        toast.success(t('Default UTM combination updated successfully'), {
          position: toast.POSITION.CENTER
        });
      } else {
        responseData = await request('/utms', {
          method: 'POST',
          body: JSON.stringify(payload)
        });
        toast.success(t('New default UTM combination created successfully'), {
          position: toast.POSITION.CENTER
        });
      }

      onSuccess(responseData);
    } catch (err) {
      toast.error(err.message || t('Failed to save UTM combination'), {
        position: toast.POSITION.CENTER
      });
    } finally {
      setLoading(false);
    }
  };
  const handleAddValue = (type) => {
    setValueTypeToCreate(type);
    setShowValueModal(true);
  };
  const handleReset = () => {
    setFormData({
      source_id: '',
      medium_id: '',
      campaign_id: '',
      term_id: '',
      content_id: '',
    });
  }
  const handleValueCreated = async () => {

    try {
      const data = await request('/utm-values');
      const valuesArray = data.data || data;

      const grouped = valuesArray.reduce((acc, value) => {
        acc[value.type] = acc[value.type] || [];
        acc[value.type].push(value);
        return acc;
      }, {});
      setLocalUtmValues(grouped);
      if (onUtmValuesChange) {
        onUtmValuesChange(grouped);
      }
    } catch (err) {
      toast.error('Failed to refresh UTM values');
    }
    setShowValueModal(false);
    setValueTypeToCreate(null);
  }

  return (
    <>
       {(status === 'Admin' || (!company || company === "null")) && (

        <UtmManager
          onValuesUpdate={(updatedValues) => {

            setLocalUtmValues(updatedValues);
            if (onUtmValuesChange) {
              onUtmValuesChange(updatedValues);
            }
          }}
        />
      )}

      <form className="space-y-5 text-about" onSubmit={handleSubmit}>

        {utmTypes.map(type => (
          <UtmSelectd
            key={type}
            utmType={type}
            name={`${type}_id`}
            label={t(`utm_${type}`)}
            value={formData[`${type}_id`]}
            LanguageSelected={LanguageSelected}
            options={
              localUtmValues[type]
                ?.filter(v => v.is_active)
                .map(v => ({ value: v.id, label: v.name })) || []
            }
            onChange={handleChange}
            onAddValue={handleAddValue}
            error={InputsErrors?.[`${type}_id`]}
          />
        ))}


        <div className="btn-pass">
          <button type="submit" className="w-full btn-edit">
            {isEditing ? t("update_default") : t("create_default")}
          </button>
        </div>

      </form>


      {showValueModal && (
        <div className="fixed z-[60] left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
          <div className="relative w-full max-h-screen findservice overflow-hidden -mt-10 rounded-xl div-sections">
            <div className="absolute -top-2 -right-2 p-4">
              <a className='w-8 h-8' onClick={() => setShowValueModal(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full ">
              <div className={`${LanguageSelected == 'ar' ? 'pl-6' : 'pr-6'}`}>
                <div className="flex items-center justify-start">
                  <p className="text-3xl text-theme m-2">
                    {t("add_new_utm_value", {
                      type: t(`utm_${valueTypeToCreate}`)
                    })}

                  </p>
                </div>
              </div>
              <UtmValueQuickForm
                typeToCreate={valueTypeToCreate}
                onSuccess={handleValueCreated}
                onCancel={() => setShowValueModal(false)}
                LanguageSelected={LanguageSelected}
                t={t}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const UTMListAndForm = () => {
  const { t } = useTranslation();

  const [latestUtm, setLatestUtm] = useState(null);
  const [utmValues, setUtmValues] = useState({});
  const [loading, setLoading] = useState(true);

  const [showFormModal, setShowFormModal] = useState(false);

  let LanguageSelected = Cookies.get('LanguageSelected');

  const fetchUtmValues = async () => {

    try {
      const data = await request('/utm-values');
      const valuesArray = data.data || data;
      const grouped = valuesArray.reduce((acc, value) => {
        acc[value.type] = acc[value.type] || [];
        acc[value.type].push(value);
        return acc;
      }, {});
      setUtmValues(grouped);
    } catch (err) {
      toast.error(t('Failed to load UTM values'), {
        position: toast.POSITION.CENTER
      });
    }
  };

  const fetchLatestUtm = async () => {
    setLoading(true);
    try {
      const data = await request('/utms/latestUtm');
      setLatestUtm(data.data && Object.keys(data.data).length > 0 ? data.data : null);
    } catch (err) {
      console.error('Failed to fetch latest UTM combination:', err);
      setLatestUtm(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUtmValues();
    fetchLatestUtm();
  }, []);

  const handleFormSuccess = () => {
    setShowFormModal(false);
    fetchLatestUtm();
  };

  const handleOpenModal = () => {
    setLoading(true);
    setShowFormModal(true);
  };

  const handleCloseModal = () => {
    setShowFormModal(false);
  };

  const handleUtmValuesChange = (updatedValues) => {
    setUtmValues(updatedValues);
  }

  return (
    <div className="w-full">

      <button
        onClick={handleOpenModal}
        type="button"
        className='w-full btn-edit'
      >

        {latestUtm
          ? t("Origine CRM")
          : t("Origine CRM")
        }
      </button>

      {showFormModal && (
        <div className="fixed z-50 inset-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">


          <div className="relative w-full max-w-lg max-h-screen overflow-auto findservice rounded-xl div-sections">

            {/* Close Button */}
            <div className="absolute -top-2 -right-2 p-4">
              <a className='w-8 h-8 cursor-pointer' onClick={handleCloseModal}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>

            <div className="w-full p-4">
              <div className="border-b pb-3 mb-4">
                <p className="text-3xl text-theme mb-2">

                  {latestUtm
                    ? t("Modifier Origine CRM")
                    : t("Ajouter Origine CRM")
                  }</p>
              </div>

              <UtmCombinationForm
                initialData={latestUtm}
                utmValues={utmValues}
                onSuccess={handleFormSuccess}
                t={t}
                LanguageSelected={LanguageSelected}
                onUtmValuesChange={handleUtmValuesChange}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UTMListAndForm;